import { useFormik } from 'formik';
import { useEffect } from 'react';
import { IParams } from '../../../../../../shared/types/redirectParams';

export const useRedirectRegisterHistory = (procedure?: IParams) => {
    const formik = useFormik({
        initialValues: {
            createdBy: '',
            updatedBy: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        const { createdBy, updatedBy } = procedure || {};
        formik.setValues({
            createdBy: createdBy
                ? `(${createdBy.username}) ${createdBy.name} ${createdBy.surname}`
                : '',
            updatedBy: updatedBy
                ? `(${updatedBy.username}) ${updatedBy.name} ${updatedBy.surname}`
                : '',
        });
    }, [procedure]);

    return {
        formik,
    };
};
